import React from 'react';
import { Flag, Star, ShieldCheck, Clock } from 'lucide-react';

const features = [
  {
    icon: <Flag className="w-10 h-10" />,
    title: "American Owned & Operated",
    description: "Reliable local cleaning professionals who take pride in serving our community."
  },
  {
    icon: <Star className="w-10 h-10" />,
    title: "Five Star Rated Service",
    description: "Consistently top rated across review platforms for our attention to detail."
  },
  {
    icon: <ShieldCheck className="w-10 h-10" />,
    title: "Professional Quality Cleaning",
    description: "High cleaning standards and rigorous training for every team member."
  },
  {
    icon: <Clock className="w-10 h-10" />,
    title: "Flexible Scheduling",
    description: "Convenient appointment availability that fits your busy modern lifestyle."
  }
];

const WhyChoose: React.FC = () => {
  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-5xl font-extrabold text-brand-navy mb-6">
            Why Choose <span className="text-brand-blue">CleanHouse NJ</span>?
          </h2>
          <p className="text-lg text-brand-navy/70">
            We combine modern efficiency with old-school reliability to deliver a premium cleaning experience.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {features.map((feature, index) => (
            <div key={index} className="text-center space-y-6">
              <div className="w-20 h-20 bg-brand-blue/5 rounded-3xl flex items-center justify-center text-brand-blue mx-auto transform transition-transform hover:rotate-6">
                {feature.icon}
              </div>
              <h3 className="text-xl font-bold text-brand-navy">{feature.title}</h3>
              <p className="text-brand-navy/60 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
